/**
 * Guía: Billeteras.
 *
 * Contenido derivado del capítulo **24** del manual: §0 (los dos saldos que
 * no son la misma cosa, y que hay una billetera por cliente y por país) y §1
 * (nadie ajusta saldos desde el panel).
 *
 * El segundo paso es el que evita una promesa imposible: no hay ninguna
 * operación de escritura, así que «te lo abono yo» no existe como opción.
 */

import type { TourFlow } from '../types';

const BILLETERAS_PATH = '/finance-wallets';

export const c24Billeteras: TourFlow = {
  id: 'admin.finance-wallets',
  chapter: '24',
  title: 'Billeteras',
  summary:
    'El dinero de los clientes: dos saldos que no se suman y por qué nadie los ajusta desde aquí.',
  href: BILLETERAS_PATH,
  requiresCountry: true,
  estimatedMin: 3,
  steps: [
    {
      id: 'intro',
      title: 'Dos saldos, y no son la misma cosa',
      body:
        'El saldo en dinero son reembolsos y bonos de campaña, en la moneda del país. ' +
        'Los puntos son fidelización, y su valor lo fija la configuración del país. ' +
        'Sumarlos no significa nada.',
      route: BILLETERAS_PATH,
    },
    {
      id: 'read-only',
      title: 'Nadie ajusta un saldo desde aquí',
      body:
        'No hay operación de bono manual ni de corrección, ni siquiera para el ' +
        'administrador general. Si un saldo está mal, la vía es el movimiento que lo ' +
        'explique —un reembolso, un bono de campaña—, no una corrección a mano.',
      target: 'admin.wallets.kpis',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'one-per-country',
      title: 'Una billetera por cliente y por país',
      body:
        'Y es el país el que fija la moneda. La misma persona en dos países tiene dos ' +
        'billeteras distintas: el saldo no viaja con ella.',
    },
    {
      id: 'ledger',
      title: 'Cada movimiento deja su rastro',
      body:
        'Los movimientos dicen de dónde salió y a dónde fue cada importe. Ante «me faltan ' +
        'puntos», o hay un movimiento que lo explica —vencimiento, revocación por ' +
        'reembolso— o hay algo que escalar. No existe la tercera opción.',
    },
  ],
};
